<template>
  <v-container fluid>
    <v-row v-if="!!itemList">
      <v-col cols="2">
        <v-sheet
            :height="componentHeight - subtractHeight"
            class="mb-0 pb-0 overflow-y-auto"
        >
          <v-list>
            <v-list-item-group v-model="taskModel" mandatory active-class="font-weight-bold" color="blue"
                               class="list-drag-item-group">
              <draggable :list="itemList" group="task_card">
                <v-list-item v-for="(item, i) in itemList" :key="i" dense
                             :class="getTaskColorClass(item.task_type.color)  + ' mt-2 pl-2 pr-0 py-0'"
                             v-show="!item.deleted || showDeleted"
                >
                  <!--                <div class="handle grab">-->
                  <!--                        <v-icon small class="ml-0">mdi-drag-variant</v-icon>-->
                  <!--                      </div>-->
                  <v-list-item-content color="blue" class="py-0 my-0">
                    <v-list-item-title class="py-0 my-0">
                      <v-row no-gutters class="flex-nowrap py-0 my-0">
                        <v-icon
                            v-if="taskModel === i"
                            small
                            color="blue"
                            class="ml-n1"
                        >
                          mdi-menu-right-outline
                        </v-icon>
                        <v-icon
                            v-if="item.property_state.error"
                            small
                            color="error"
                        >
                          mdi-alert-octagon-outline
                        </v-icon>
                        {{ item.name }}
                        <v-avatar color="blue-grey darken-2" size="16" class="py-0 mx-1">
                          <span class="white--text">{{ item.subtasks.length }}</span>
                        </v-avatar>
                      </v-row>
                    </v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-icon class="py-0 my-0">
                    <span class="mt-3">{{ $t('groups.' + item.task_type.group) }}</span>
                  </v-list-item-icon>
                  <v-list-item-action>
                    <v-edit-dialog
                        :return-value.sync="item"
                    >
                      <v-icon v-if="item.deleted">mdi-delete-restore</v-icon>
                      <!--                      <v-icon small v-else>mdi-dots-horizontal</v-icon>-->
                      <v-icon small v-else>mdi-pencil-outline</v-icon>
                      <template v-slot:input>
                        <v-text-field
                            v-model="item.name"
                            dense
                            outlined
                            class="mt-3"
                            :filled="readonly"
                            :readonly="readonly"
                            counter="20"
                        ></v-text-field>
                        <v-select
                            v-model="item.task_type"
                            item-text="name"
                            :label="$t('columns.task_type')"
                            outlined
                            :items="common.task_types"
                            dense
                            :return-object="true"
                            :filled="readonly"
                            :readonly="readonly"
                        >
                        </v-select>
                        <BaseDeleteIcon
                            v-model="item.deleted"
                            show_label
                            :filled="readonly"
                            :readonly="readonly"
                            class="mb-5"
                        />
                      </template>
                    </v-edit-dialog>
                  </v-list-item-action>
                </v-list-item>
              </draggable>
            </v-list-item-group>
          </v-list>
          <v-edit-dialog
              :return-value.sync="newItem"
              :save-text="$t('ok')"
              @open="newItem = JSON.parse(JSON.stringify(newDefaultItem))"
              @save="onSaveNewTask"
              :large="!!newItem.name && !!newItem.task_type"
              v-if="!readonly"
          >
            <v-icon color="blue-grey lighten-2" class="ml-0 mt-3">mdi-plus-box-outline</v-icon>
            <template v-slot:input>
              <v-text-field
                  v-model="newItem.name"
                  dense
                  outlined
                  class="mt-3"
                  :filled="readonly"
                  :readonly="readonly"
                  counter="20"
                  maxlength="20"
              ></v-text-field>
              <v-select
                  v-model="newItem.task_type"
                  item-text="name"
                  :label="$t('columns.task_type')"
                  outlined
                  :items="common.task_types"
                  dense
                  :return-object="true"
                  :filled="readonly"
                  :readonly="readonly"
              >
              </v-select>
              <v-checkbox
                  v-model="newItem.deleted"
                  :label="$t('columns.deleted')"
                  outlined
                  dense
                  :filled="readonly"
                  :readonly="readonly"
              >
              </v-checkbox>
              <v-toolbar v-if="!newItem.name || !newItem.task_type" elevation="0" height="52"></v-toolbar>
            </template>
          </v-edit-dialog>
        </v-sheet>
      </v-col>
      <v-col cols="10">
        <v-sheet
            v-if="!!itemList[taskModel] && (itemList[taskModel].deleted === false || showDeleted)"
            :height="componentHeight - subtractHeight"
            class="mb-0 pb-0"
        >
          <v-sheet class="mb-3">
            <v-tabs
                v-model="tabSubtask"
                align-with-title
                height="24"
                background-color="grey lighten-2"
            >
              <v-tab
                  v-for="(subTask, index) in filteredSubtask"
                  :key="index"
                  class="not-text-transform"
              >
                <v-icon
                    v-if="!!subTask && !!subTask.property_state.error"
                    small
                    class="ml-n3"
                    color="error"
                >
                  mdi-alert-octagon-outline
                </v-icon>
                {{ subTask.name }}
              </v-tab>
              <v-spacer></v-spacer>

              <v-edit-dialog
                  :return-value.sync="newSubtask"
                  @open="newSubtask = JSON.parse(JSON.stringify(newDefaultSubtask))"
                  @save="onSaveNewSubtask(taskModel)"
                  :save-text="$t('add_new_subtask')"
                  :large="!!newSubtask.name"
                  v-if="!readonly"
              >
                <v-icon color="blue-grey lighten-2" class="ml-0 mt-0">mdi-pencil-box-outline</v-icon>
                <template v-slot:input>

                  <v-list>
                    <draggable :list="itemList[taskModel].subtasks" group="subtask_card">
                      <v-list-item v-for="(subtask, i) in itemList[taskModel].subtasks" :key="i" dense>
                        <v-list-item-icon>
                          <v-icon small>mdi-swap-vertical</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content color="blue" class="py-0 my-0">
                          <v-list-item-title class="py-0 my-0">
                            {{ subtask.name }}
                          </v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                          <v-icon v-if="!!subtask.deleted">mdi-delete-outline</v-icon>
                        </v-list-item-action>
                      </v-list-item>
                    </draggable>
                  </v-list>

                  <v-text-field
                      v-model="newSubtask.name"
                      :label="$t('new_subtask_name')"
                      dense
                      outlined
                      class="mt-3"
                  ></v-text-field>
                </template>
              </v-edit-dialog>

            </v-tabs>
          </v-sheet>
          <v-sheet class="mb-0 pb-0" v-if="!!filteredSubtask[tabSubtask]">
            <v-tabs height="24" background-color="grey lighten-3">
              <v-tab class="not-text-transform">Description</v-tab>
              <v-tab class="not-text-transform">Machines</v-tab>
              <v-tab class="not-text-transform">Parameters</v-tab>
              <v-spacer></v-spacer>
              <BaseDeleteIcon
                  v-if="filteredSubtask.filter(row => !row.deleted).length > 1 || filteredSubtask[tabSubtask].deleted"
                  v-model="filteredSubtask[tabSubtask].deleted"
                  :filled="readonly"
                  :readonly="readonly"
                  class="mt-0"
                  @input="onDeleteSubtask"
              />

              <v-tab-item>
                <v-sheet class="pr-3 mt-1 mb-0 pb-0 overflow-y-auto" :height="componentHeight - subtractHeight - 70">
                  <v-row no-gutters class="mt-2">
                    <v-col cols="12">
                      <v-text-field
                          v-model="filteredSubtask[tabSubtask].name"
                          :label="$t('columns.name')"
                          dense
                          :filled="readonly"
                          :readonly="readonly"
                          outlined
                          :error="filteredSubtask[tabSubtask].property_state.name.error"
                      />
                    </v-col>
                  </v-row>
                  <draggable :list="filteredSubtask[tabSubtask].library_docs" group="task_card">
                    <v-row
                        v-for="(item, index) in filteredSubtask[tabSubtask].library_docs"
                        :key="index"
                        v-if="showDeleted || item.deleted === false"
                        class="mt-n3"
                    >
                      <TipTapModalEditor v-model="item.content" class="mx-0" :readonly="readonly">
                        <template v-slot:bar.end>
                          <v-chip small label outlined class="px-1">
                            <small>ver. {{ item.version }}</small>
                          </v-chip>
                          <v-chip small label outlined class="px-0">
                            <v-btn
                                icon
                                small
                                :to="{name:'LibraryDocItem', params: { itemUid: item.uid}}"
                            >
                              <v-icon>mdi-fullscreen</v-icon>
                            </v-btn>
                          </v-chip>
                          <v-chip small label outlined class="px-0">
                            <BaseDeleteIcon v-model="item.deleted"></BaseDeleteIcon>
                          </v-chip>
                        </template>
                      </TipTapModalEditor>
                    </v-row>
                  </draggable>
                  <v-row>
                    <BaseDialogSelectFromTable
                        v-if="!parentChanged"
                        tableComponentPath="/LibraryDoc/LibraryDoc/LibraryDocTable"
                        @choice="actionImport($event)"
                    >
                      <template v-slot:default="{openDialog}">
                        <v-icon
                            color="blue-grey lighten-2"
                            class="ml-3 mt-3"
                            @click="openDialog()"
                            :disabled="readonly"
                        >
                          mdi-import
                        </v-icon>
                      </template>
                    </BaseDialogSelectFromTable>
                    <v-icon
                        color="blue-grey lighten-2"
                        class="ml-0 mt-3"
                        :disabled="readonly"
                        @click="newDocument(filteredSubtask[tabSubtask].library_docs)"
                    >
                      mdi-plus-box-outline
                    </v-icon>
                  </v-row>
                </v-sheet>
              </v-tab-item>

              <v-tab-item>
                <MachineAttribute
                    :machines="filteredSubtask[tabSubtask].machines_attributes"
                    :readonly="readonly"
                    class="px-0"
                />
              </v-tab-item>

              <v-tab-item>
                <v-row>
                  <SubtaskAttributeCardList
                      :item-list="filteredSubtask[tabSubtask].attributes"
                      :readonly="readonly"
                      :show-deleted="showDeleted"
                      class="mt-5 mb-3"
                  ></SubtaskAttributeCardList>
                </v-row>
              </v-tab-item>
            </v-tabs>
          </v-sheet>

        </v-sheet>
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
import {v4 as uuidv4} from "uuid";
import draggable from "vuedraggable";
import BaseCardList from "@/components/Base/BaseCardList";
import colorClass from "@/commonFunction/colorClassDict"
import SubtaskAttributeCardList from "@/components/Product/Task/SubtaskAttributeCardList";
import TipTapModalEditor from "@/components/TipTap/TipTapModalEditor";
import Sortable from "sortablejs";
import MachineAttribute from "@/components/Product/Task/MachineAttribute";
import BaseDeleteIcon from "@/components/Base/BaseDeleteIcon";
import LibraryDocTable from "@/components/LibraryDoc/LibraryDoc/LibraryDocTable";
import BaseDialogSelectFromTable from "@/components/Base/BaseDialogSelectFromTable";

export default {
  name: 'TaskCard',
  props: {
    componentHeight: {type: [Number], default: 0},
    // subtractHeight: {type: [Number], default: 0},
    itemList: {default: () => []},
    readonly: {type: [Boolean], default: false},
    common: {
      default: () => {
      }
    },
    showDeleted: {type: [Boolean], default: true},
    tabs: {
      type: [Function], default: function () {
        return []
      }
    },
    defaultTab: {type: [Number], default: 0},
    defaultTabAfterAdd: {type: [Number], default: 0},
    dto_import_library_doc_model: {type: [String], default: 'ProductImportFromLibraryDocCommandDTO'},
    fetchAction: {
      type: [Function], default: function ({dto, dto_action_model}) {
        return null
      }
    },
    parentEditedItem: {default: null},
    parentChanged: {type: [Boolean], default: true},
  },

  components: {
    draggable,
    BaseCardList,
    SubtaskAttributeCardList,
    TipTapModalEditor,
    MachineAttribute,
    BaseDeleteIcon,
    LibraryDocTable,
    BaseDialogSelectFromTable,
  },

  computed: {
    filteredSubtask() {
      if (!this.showDeleted)
        return this.itemList[this.taskModel].subtasks.filter(row => !row.deleted)
      else
        return this.itemList[this.taskModel].subtasks
    },

  },

  watch: {
    itemList: {
      handler(newValue, oldValue) {
        // console.log('watch')
        this.emitValue()
      },
      deep: true
    }
  },

  methods: {
    emitValue() {
      // console.log('emitValue')
      this.$emit('update:itemList', this.itemList)
    },

    onDeleteSubtask(emit) {
      // console.log('onDeleteSubtask', emit)
      if (!!emit)
        this.tabSubtask = 0
    },

    getTaskColorClass(color) {
      return colorClass.getColorClass(color)
    },

    onSaveNewTask() {
      // console.log('onSaveNewTask before', this.itemList, this.newItem)
      this.newItem.uid = uuidv4()
      this.newItem.subtasks[0].uid = uuidv4()
      this.itemList.push(this.newItem)
      // console.log('onSaveNewTask after', this.itemList, this.newItem)
    },

    onSaveNewSubtask(taskModel) {
      // console.log('onSaveNewSubtask before', this.itemList, this.newSubtask)
      this.newSubtask.uid = uuidv4()
      this.itemList[taskModel].subtasks.push(this.newSubtask)
      // console.log('onSaveNewSubtask after', this.itemList, this.newSubtask)
    },

    newDocument(library_docs) {
      let newDocument = {
        uid: uuidv4(),
        deleted: false,
      }
      library_docs.push(newDocument)
    },

    tabsList(item) {
      let name = this.$t('no_name')
      let group = 'no_name'
      if (!!item.name)
        name = item.name
      if (!!item.task_type)
        group = item.task_type.group
      let tabs = [this.$t('groups.' + group), name]
      if (!!item && !!item.subtasks)
        item.subtasks.forEach(function (row) {
          if (row.deleted === false) tabs.push(row.name)
        })
      return tabs
    },

    subtaskList(item) {
      let tabs = []
      if (!!item && !!item.subtasks)
        item.subtasks.forEach(function (row) {
          if (row.deleted === false) tabs.push(row.name)
        })
      return tabs
    },

    getTypeOfCloseList() {
      let result = []
      for (const [key, value] of Object.entries(this.$t('type_of_close_list'))) {
        result.push({text: value, value: key})
      }
      return result
    },

    getTitleBodyColor({item, index}) {
      if (!!item.task_type)
        return item.task_type.color
      else
        return null
    },
    getTabColor(item, tabindex) {
      if (tabindex <= 1) {
        return this.taskColor
      }
      return this.subtaskColor
    },
    addTab(item) {
      item.subtasks.push({uid: uuidv4(), name: this.new_subtask_name, deleted: false})
    },

    actionImport(selectedItem) {
      // console.log('actionImportFromLibrary', selectedItemList, this.dto_import_library_doc_model)
      let dto_import = {
        current_dto: this.parentEditedItem,
        current_uid: this.filteredSubtask[this.tabSubtask].uid,
        selected_uid_list: [selectedItem.uid],
      }
      if (!!selectedItem)
        this.fetchAction({dto: dto_import, dto_action_model: this.dto_import_library_doc_model})
    },
  },

  async mounted() {
    let item_group = document.querySelector(".list-drag-item-group")
    // console.log('querySelector', item_group)
    // Sortable.create(item_group, {handle: ".handle", sort: true, onUpdate: this.saveOrder})
  }
  ,

  data() {
    return {
      subtractHeight: 50,
      newItem: {name: null, task_type: null},
      newSubtask: {name: null},
      newDefaultItem: {
        name: null,
        deleted: false,
        uid: uuidv4(),
        task_type: null,
        property_state: {},
        subtasks: [
          {
            name: this.$t('no_name_subtask'),
            deleted: false,
            uid: uuidv4(),
            property_state: {},
            attributes: [],
            machines_attributes: [],
            library_docs: [],
          }]
      },
      newDefaultSubtask: {
        name: null,
        deleted: false,
        uid: uuidv4(),
        property_state: {},
        attributes: [],
        machines_attributes: [],
        library_docs: [],
      },
      taskModel: null,
      tabSubtask: 0,
      new_subtask_name: null,
      taskColor: 'indigo darken-4',
      subtaskColor: 'brown',
      importLabels: {
        btn: this.$t('import'),
        confirm: this.$t('import'),
        cancel: this.$t('cancel'),
        text: this.$t('import_message'),
      },
    }
  }
}
</script>

<style scoped>
.border {
  border: 1px dotted darkblue;
}

.no-spin input[type='number'] {
  -moz-appearance: textfield;
  /*width: 50px;*/
}

.not-text-transform {
  text-transform: none !important;
}


</style>

<i18n>
{
  "en": {
    "new_subtask_name": "New subtask name",
    "add_new_subtask": "Add",
    "descriptions": "Description",
    "machines": "Machines",
    "parameters": "Parameters",
    "no_name": "No name",
    "no_name_subtask": "No name subtask",
    "new_task": "New task",
    "import_message": "Do you want to import?",
    "ok": "OK",
    "cancel": "Cancel",
    "columns": {
      "task": "Task",
      "name": "Name",
      "task_type": "Task type",
      "description": "Description",
      "type_of_close": "Type of close",
      "deleted": "Deleted"
    },
    "groups": {
      "smd": "SMD",
      "tht": "THT",
      "generic": "Generic",
      "external": "External",
      "no_name": "No name",
      "no_name_subtask": "Keine Namensunteraufgabe"
    },
    "type_of_close_list": {
      "full": "Full",
      "one": "One",
      "partial": "Partial"
    }
  },
  "de": {
    "new_subtask_name": "New subtask name",
    "add_new_subtask": "Hinzufügen",
    "description": "Beschreibung",
    "machines": "Maschinen",
    "parameters": "Parameter",
    "no_name": "Kein Name",
    "new_task": "Neue Aufgabe",
    "import_message": "Möchten Sie importieren?",
    "ok": "OK",
    "cancel": "cancel",
    "columns": {
      "task": "Task",
      "name": "Name",
      "task_type": "Aufgabentyp",
      "description": "Beschreibung",
      "type_of_close": "Art des Abschlusses",
      "deleted": "Gelöscht"
    },
    "groups": {
      "smd": "SMD",
      "tht": "THT",
      "generic": "Generisch",
      "external": "Extern",
      "no_name": "Kein Name"
    },
    "type_of_close_list": {
      "full": "Voll",
      "one": "Eins",
      "partial": "Teilweise"
    }
  }
}
</i18n>
